export default class RegistrationData {
  /** @type {string?} */ Book = null
  /** @type {string?} */ RegisterOfCompaniesLocation = null
  /** @type {string?} */ Sheet = null
  /** @type {string?} */ Folio = null
  /** @type {string?} */ Section = null
  /** @type {string?} */ Volume = null
  /** @type {string?} */ AdditionalData = null
}
